import { useI18n, type Translations } from '../../i18n';
import type { BoutLevel } from '../../types';
import { BADGE_XS } from '../shared/badgeSize';

/** One colour of its own in four shades: purple, blue and gray already mean
 *  a stage, a corner or a division in the same rows (review, 2026-10-17).
 *  #643 — Pro is the darkest shade. */
export const LEVEL_CLS: Record<BoutLevel, string> = {
  pro: 'bg-teal-700 text-white font-semibold',
  high: 'bg-teal-200 text-teal-900 font-semibold',
  medium: 'bg-teal-100 text-teal-800',
  low: 'bg-teal-50 text-teal-700',
};

/** #643 — the name of a level: one place for every view. */
export function levelLabel(t: Translations, level: BoutLevel): string {
  return { pro: t.bout.levelPro, high: t.bout.levelHigh, medium: t.bout.levelMedium, low: t.bout.levelLow }[level];
}

/** #622 — the level of a bout (backend lib/boutLevel.ts). The server sends it
 *  only to the roles of the Officials menu; the page shows what it received.
 *  "≈" marks a level from an estimate of the experience (a past bout). */
export default function BoutLevelPill({ level, estimated = false, size = 'sm' }: { level: BoutLevel; estimated?: boolean; size?: 'xs' | 'sm' }) {
  const { t } = useI18n();
  const label = levelLabel(t, level);
  return (
    <span data-testid="bout-level" data-level={level} data-estimated={estimated}
      className={`badge whitespace-nowrap ${LEVEL_CLS[level]} ${size === 'xs' ? `${BADGE_XS} px-1` : ''}`}>
      {estimated && '≈ '}{t.bout.levelPill.replace('{level}', label)}
    </span>
  );
}
